<app-header></app-header>
<section class="container-xxl">
   
   
    <div class="inner-page"> 
        <div class="inner-page-details">

 <!-- for content page  -->              
<div class="row"> 
 
    <div class="col-lg-12"> 
            <!-- INNER CONTENT - STARTS -->
       
    <div class="inner-page-sidedetails">
        <div class="row">
            <div class="col-lg-12">
                <div id="section-New"></div>
                <div class="inner-banner-image">
                    <div class="image-area">
                        <ng-container *ngIf="contentImg!==''; else elseBanner">
                            <img class="screen-reader" src="{{backendUrl}}storage/app/uploads/{{contentImg}}" alt="inner-banner-image">
                        </ng-container> 
                        <ng-template #elseBanner>
                            <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                        </ng-template>
                    </div> 
                </div>  
                <div class="details"> 
                    <div class="title">
                        <h2 class="screen-reader font-adjust" *ngIf="language=='English'" [innerHtml]="encDec.decodeHtml(pgTitleEng)"></h2>
                        <h2 class="screen-reader font-adjust" *ngIf="language=='Hindi'" [innerHtml]="encDec.decodeHtml(pgTitleHnd)"></h2>
                    </div>
                    <div class="description">
                        <div class="inner-content">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="content-details">
                                        <div class="content-part font-adjust screen-reader" id="conEnglish">
                                        </div>
                                        <!-- <div class="content-part font-adjust screen-reader" *ngIf="language=='English'" [innerHtml]="encDec.decodeHtml(contentInEng)">
                                        </div>
                                        <div class="content-part font-adjust screen-reader" *ngIf="language=='Hindi'" [innerHtml]="encDec.decodeHtml(contentInHnd)">
                                        </div> -->
    
                                    </div>
                                </div>
                            </div>
                        </div>
    
                    </div>
                </div>
            </div>
        </div>
    </div>

        <!-- INNER CONTENT - ENDS -->
    </div>
</div>






 

        </div>
    </div> 

</section>

<app-clients></app-clients>

<app-footer></app-footer> 